var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.599,
    height: 22.421,
    viewBox: "0 0 21.599 22.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-connections-50",
    transform: "translate(-0.628 49.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11542",
    "data-name": "Path 11542",
    d: "M.66-49.339c-.177.184.4,1.1,1.328,2.07l1.638,1.748H2.21c-.8,0-1.417.184-1.417.46,0,.23,1.018.46,2.214.46H5.22v-2.3c0-1.288-.177-2.3-.443-2.3-.221,0-.443.644-.443,1.472v1.472l-1.683-1.7C1.722-48.925.837-49.523.66-49.339Z",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11543",
    "data-name": "Path 11543",
    d: "M41.524-47.9l-1.638,1.7v-1.518c0-.782-.177-1.472-.443-1.472-.221,0-.443,1.012-.443,2.3v2.3h2.214c1.24,0,2.214-.23,2.214-.46,0-.276-.62-.46-1.417-.46H40.594L42.277-47.3c.93-.966,1.505-1.886,1.284-2.024S42.409-48.816,41.524-47.9Z",
    transform: "translate(-21.382 -0.017)",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11544",
    "data-name": "Path 11544",
    d: "M20.79-40.264A2.279,2.279,0,0,0,22.3-36.4a2.505,2.505,0,0,0,2.214-2.3A2.505,2.505,0,0,0,22.3-41,2.351,2.351,0,0,0,20.79-40.264ZM23.4-38.7c0,.828-.266,1.2-1.018,1.288a1.067,1.067,0,0,1-1.24-.552c-.443-1.2.177-2.208,1.24-2.024C23.137-39.9,23.4-39.528,23.4-38.7Z",
    transform: "translate(-10.876 -4.521)",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11545",
    "data-name": "Path 11545",
    d: "M9.037-34.264a2.213,2.213,0,0,0-.044,3.128c.62.6.576.736-.31,1.242A2.509,2.509,0,0,0,7-27.318c0,.966.221,1.058,1.993,1.058,1.107,0,1.993-.23,1.993-.46,0-.276-.708-.46-1.55-.46-1.063,0-1.55-.23-1.55-.69,0-.874,1.417-1.61,3.144-1.61,1.107,0,1.328-.138.974-.506-.4-.414-.354-.69.133-1.2A2.311,2.311,0,0,0,10.542-35,2.351,2.351,0,0,0,9.037-34.264ZM11.649-32.7c0,.828-.266,1.2-1.018,1.288a1.067,1.067,0,0,1-1.24-.552c-.443-1.2.177-2.208,1.24-2.024C11.384-33.9,11.649-33.528,11.649-32.7Z",
    transform: "translate(-3.551 -7.761)",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11546",
    "data-name": "Path 11546",
    d: "M30.75-34.264a2.2,2.2,0,0,0-.089,3.082c.487.506.531.782.133,1.2-.354.368-.133.506.974.506,1.727,0,3.144.736,3.144,1.61,0,.46-.487.69-1.55.69-.841,0-1.55.184-1.55.46,0,.23.886.46,1.993.46,1.771,0,1.993-.092,1.993-1.058a2.509,2.509,0,0,0-1.683-2.576c-.886-.506-.93-.644-.31-1.242A2.314,2.314,0,0,0,32.255-35,2.351,2.351,0,0,0,30.75-34.264ZM33.362-32.7c0,.828-.266,1.2-1.018,1.288-1.063.184-1.683-.828-1.24-2.024a1.067,1.067,0,0,1,1.24-.552C33.1-33.9,33.362-33.528,33.362-32.7Z",
    transform: "translate(-16.408 -7.761)",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11547",
    "data-name": "Path 11547",
    d: "M19.037-29.264a2.213,2.213,0,0,0-.044,3.128c.62.6.576.736-.31,1.242A2.509,2.509,0,0,0,17-22.318c0,1.012.177,1.058,3.542,1.058s3.542-.046,3.542-1.058A2.509,2.509,0,0,0,22.4-24.894c-.886-.506-.93-.644-.31-1.242A2.314,2.314,0,0,0,20.542-30,2.351,2.351,0,0,0,19.037-29.264ZM21.649-27.7c0,.828-.266,1.2-1.018,1.288a1.067,1.067,0,0,1-1.24-.552c-.443-1.2.177-2.208,1.24-2.024C21.384-28.9,21.649-28.528,21.649-27.7Zm.708,3.68a1.706,1.706,0,0,1,.841,1.15c0,.552-.62.69-2.657.69s-2.657-.138-2.657-.69C17.886-24.25,20.631-24.94,22.358-24.02Z",
    transform: "translate(-9.123 -10.462)",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11548",
    "data-name": "Path 11548",
    d: "M.81-10.54c0,.23.62.46,1.417.46H3.644L2.005-8.332c-2.17,2.3-1.55,2.944.664.69l1.683-1.7v1.472c0,.828.221,1.472.443,1.472.266,0,.443-1.058.443-2.3V-11H3.024C1.828-11,.81-10.816.81-10.54Z",
    transform: "translate(-0.017 -20.722)",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11549",
    "data-name": "Path 11549",
    d: "M39-8.7c0,1.242.221,2.3.443,2.3.266,0,.443-.644.443-1.472V-9.344l1.683,1.7c.93.966,1.815,1.564,1.993,1.38s-.4-1.1-1.328-2.07L40.594-10.08h1.417c.8,0,1.417-.23,1.417-.46,0-.276-.974-.46-2.214-.46H39Z",
    transform: "translate(-21.382 -20.722)",
    fill: "var(--mainColor)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMap);
export default __webpack_public_path__ + "static/media/showMap.db02b085893d2ebe716a2128f97d4005.svg";
export { ForwardRef as ReactComponent };